export const createErrorWrapper =
  (code, defaultMessage = 'Request was unsuccessful') =>
  (originalError) => ({
    code,
    message: originalError.response
      ? originalError.response.data.message || defaultMessage
      : defaultMessage,
    originalError,
  });
